import { render, staticRenderFns } from "./UploadPanActivity.vue?vue&type=template&id=56028767&scoped=true&"
import script from "./UploadPanActivity.vue?vue&type=script&lang=js&"
export * from "./UploadPanActivity.vue?vue&type=script&lang=js&"
import style0 from "./UploadPanActivity.vue?vue&type=style&index=0&id=56028767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56028767",
  null
  
)

export default component.exports